module.exports = __webpack_public_path__ + "static/media/home_japan_main3_sophy.d7adb75a.svg";